export const SETTINGS_KEYS = {
  showLabels: 'grafana.explore.logs.showLabels',
  showTime: 'grafana.explore.logs.showTime',
  wrapLogMessage: 'grafana.explore.logs.wrapLogMessage',
  prettifyLogMessage: 'grafana.explore.logs.prettifyLogMessage',
  logsSortOrder: 'grafana.explore.logs.sortOrder',
  logContextWrapLogMessage: 'grafana.explore.logs.logContext.wrapLogMessage',
  commonLabels: 'grafana.explore.logs.commonLabels',
};

export const SETTING_KEY_ROOT = 'grafana.explore.logs';

export const visualisationTypeKey = 'grafana.explore.logs.visualisationType';
